<i *ngIf="counter > 0" class=" fal fa-2x fa-conveyor-belt-alt "></i>
<!-- <i *ngIf="counter == 0" class="fa fa-2x fa-siren "></i> -->